type BioStampCardProps = {
  className?: string;
  imgClassName?: string;
};

export default function BioStampCard({ className = '', imgClassName = '' }: BioStampCardProps) {
  return (
    <div className={`h-28 md:h-32 flex items-center justify-center ${className}`}>
      <img
        src="https://storage.helloreaddy.io/project_files/026e1453-3796-4207-bff6-367c8dc212ea/7ee4f557-a6bc-4be6-a958-dcd0c31e7fb9_compressed_SenderVerification-bioStamp.webp"
        alt="bioMail bioStamp secure sender verification card"
        title="bioMail bioStamp biometric verification card"
        className={`w-full h-full object-contain ${imgClassName}`}
      />
    </div>
  );
}